import React, { useState } from 'react';
import styled from 'styled-components';
import { Color, Text } from '../../styles/common';
import authApi from '../../api/auth';
import Button from '../../components/common/Button';

function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [toggleText, setToggleText] = useState(true);

  const onEmailHandler = (e: React.FormEvent<HTMLInputElement>) => setEmail(e.currentTarget.value);
  const onPasswordHandler = (e: React.FormEvent<HTMLInputElement>) => setPassword(e.currentTarget.value);
  const onToggleNewUser = () => setToggleText(prev => !prev);
  
  const onSubmitAuth = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    toggleText ? authApi.signUp(email, password) : authApi.signIn(email, password);
  };

  return (
    <Container>
      <div>
        <img src='/images/logo.png' alt='auth-logo' />
        <p>{toggleText ? 'SIGN UP' : 'SIGN IN'}</p>
      </div>

      <form onSubmit={onSubmitAuth}>
        <label>이메일</label>
        <input
        type='email'
        value={email}
        onChange={onEmailHandler} 
        placeholder='이메일을 입력해 주세요.'/>

        <label>비밀번호</label>
        <input
        type='password'
        value={password}
        onChange={onPasswordHandler} 
        placeholder='비밀번호를 입력해 주세요.'/>

        <Button
          width='100%'
          height='30px'
          color={Color.WHITE}
          fontSize= {Text.SM}
          backgroundColor={Color.BLUE100}
          backgroundColorHover={Color.BLUE200}
        > {toggleText ? 'Sign up' : 'Sign in'} </Button>
      </form>

      <p onClick={onToggleNewUser}>{toggleText ? 'Sign in' : 'Sign up'}</p>
    </Container>
  )
}

export default SignIn;

const Container = styled.div`
  padding: 10px 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${ Color.WHITE };
  border-radius: 10px;
  box-shadow: 1px 1px 10px 1px ${ Color.GRAY100 };

  div {
    padding: 30px 0;

    p {
      margin: 0;
      font-size: ${ Text.MD };
    }
  }

  form {
    display: flex;
    flex-direction: column;
    
    label {
      font-size: ${ Text.SM };
    }

    input {
      width: 250px;
      height: 30px;
      margin-bottom: 30px;
      outline: none;
      border: none;
      border-bottom: 1px solid ${ Color.GRAY100 };
    }
  }

  &>p {
    color: ${ Color.BLACK };
    font-size: ${ Text.SM };
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: ${ Color.BLUE100 };
      text-decoration: underline;
    }
  }
`